import {PencilIcon} from '@primer/octicons-react'
import {Box, Text, Heading, type SxProp, Button} from '@primer/react'

export type StyledHeadingProps = {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
} & SxProp

type SectionHeaderProps = {
  title: string
  buttonProps?: React.HTMLAttributes<HTMLButtonElement>
  headingProps?: StyledHeadingProps
} & SxProp

export function SectionHeader({
  title,
  buttonProps,
  headingProps: {as: Component = 'h3', ...headingProps} = {},
  ...props
}: SectionHeaderProps) {
  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        ...props.sx,
      }}
    >
      <Heading
        as={Component}
        sx={{
          top: 1,
          position: 'absolute',
          left: 2,
          fontSize: 1,
          fontWeight: 'bold',
          color: 'fg.default',
          pointerEvents: 'none',
          ...headingProps,
        }}
      >
        {title}
      </Heading>
      <Button
        {...buttonProps}
        variant="invisible"
        size="small"
        trailingAction={PencilIcon}
        block
        sx={{alignContent: 'start'}}
      >
        <Text className="sr-only" sx={{fontWeight: 600, fontSize: 0, lineHeight: '20px', color: 'fg.muted'}}>
          {`Edit ${title}`}
        </Text>
      </Button>
    </Box>
  )
}

try{ SectionHeader.displayName ||= 'SectionHeader' } catch {}